<div *ngIf="data$ | async as data; else processing">
  <div class="payment-info-container">
    <div>
      <div *ngIf="data.paymentInfo && data.paymentConfigured && data.merchantConfigured">
        <div class="primary-credit-card-info">
          <div class="credit-card-info type-and-last-four">
            <span>
              <i [ngClass]="data.paymentClass" class="pf" id="brand-icon"></i>
              <span class="card--bold credit-card-info__number">
                {{
                  'ACCOUNT_BILLING_SETTINGS.PAYMENT_INFO.ENDING_IN_LAST_FOUR_DIGITS'
                    | translate: { lastFourDigits: data.paymentInfo.lastFourDigits }
                }}
              </span>
              {{
                'ACCOUNT_BILLING_SETTINGS.PAYMENT_INFO.EXPIRES_ON_DATE'
                  | translate: { month: data.paymentInfo.expiryMonth, year: data.paymentInfo.expiryYear }
              }}
            </span>
          </div>
          <span class="credit-card-info credit-card-info__name card--bold">
            {{ data.paymentInfo.cardholderName }}
          </span>
          <span class="credit-card-info address">
            {{ data.paymentInfo.address }}, {{ data.paymentInfo.city }}, {{ data.paymentInfo.state }}
            {{ data.paymentInfo.country }}
          </span>
        </div>
      </div>
      <div *ngIf="!data.paymentConfigured && data.merchantConfigured">
        <div class="client">
          {{ 'ACCOUNT_BILLING_SETTINGS.PAYMENT_INFO.NO_PAYMENT_INFORMATION_CONFIGURED' | translate }}
        </div>
      </div>
      <div *ngIf="!data.merchantConfigured">
        <div class="client">
          {{ 'ACCOUNT_BILLING_SETTINGS.PAYMENT_INFO.NO_PAYMENT_INFORMATION_CONFIGURED' | translate }}
          <br />
          <span class="small">
            {{ 'ACCOUNT_BILLING_SETTINGS.PAYMENT_INFO.ADD_A_BILLING_CONTACT_FIRST' | translate }}
          </span>
        </div>
      </div>
    </div>
    <a class="edit-link" (click)="openEditModal()" *ngIf="data.merchantConfigured && editable">
      <span *ngIf="!data.paymentConfigured">{{ 'COMMON.ACTION_LABELS.ADD' | translate | uppercase }}</span>
      <span *ngIf="data.paymentConfigured">{{ 'COMMON.ACTION_LABELS.EDIT' | translate | uppercase }}</span>
    </a>
  </div>
</div>
<ng-template #processing>
  <div class="spinner">
    <mat-spinner [strokeWidth]="3" [diameter]="24"></mat-spinner>
  </div>
</ng-template>
